import lazyScreen from '../utils/lazyScreen';
const WalletTrans = lazyScreen(() => import('../pages/wallet/WalletTrans/index.js'), 'pages/wallet/WalletTrans/index.js');

export default [
    {
        path: '/wallet/WalletTrans',
        component: WalletTrans
    }
];
